(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root = document) {
    root.querySelectorAll('[data-review-controls]').forEach(controls => {
      if (controls.dataset.ready) return;
      const track = document.getElementById(controls.dataset.track);
      if (!track || track.children.length < 2) { controls.hidden = true; return; }
      controls.dataset.ready = 'true';
      controls.hidden = false;
      let playing = !reduced.matches, timer;
      const button = controls.querySelector('[data-review-play]');
      function render() { button.textContent = playing ? 'Pause reviews' : 'Play reviews'; button.setAttribute('aria-pressed', String(playing)); }
      function move(direction) {
        const card = track.firstElementChild;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        const max = track.scrollWidth - track.clientWidth;
        let next = track.scrollLeft + direction * step;
        if (next > max + 2) next = 0;
        if (next < -2) next = max;
        track.scrollTo({ left: Math.max(0, Math.min(max, next)), behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      function pause() { playing = false; render(); }
      controls.querySelector('[data-review-prev]').addEventListener('click', () => { pause(); move(-1); });
      controls.querySelector('[data-review-next]').addEventListener('click', () => { pause(); move(1); });
      button.addEventListener('click', () => { playing = !playing; render(); });
      track.addEventListener('pointerdown', pause);
      track.addEventListener('focusin', pause);
      track.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); pause(); move(event.key === 'ArrowRight' ? 1 : -1); } });
      render();
      timer = setInterval(() => {
        if (!controls.isConnected) { clearInterval(timer); return; }
        const rect = track.getBoundingClientRect();
        if (playing && !document.hidden && !track.matches(':hover') && !controls.matches(':hover') && !controls.contains(document.activeElement) && rect.top < innerHeight && rect.bottom > 0) move(1);
      }, 8000);
      reduced.addEventListener('change', () => { if (reduced.matches) pause(); });
    });
    root.querySelectorAll('.tn-hotspots').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      group.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) group.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
        });
      });
    });
    root.querySelectorAll('[data-warranty-content]').forEach(container => {
      if (container.dataset.faqPrepared) return;
      container.dataset.faqPrepared = 'true';
      const heading = [...container.querySelectorAll('h2,h3,h4')].find(node => /frequently asked questions/i.test(node.textContent));
      if (!heading) return;
      const faq = document.createElement('div');
      faq.className = 'tn-warranty-faq';
      faq.setAttribute('data-original-faq', '');
      const followingHeadings = [...container.querySelectorAll('h2,h3,h4')].filter(node => heading.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
      const end = followingHeadings.find(node => !/\?\s*$/.test(node.textContent.trim()));
      const range = document.createRange(); range.setStartAfter(heading);
      if (end) range.setEndBefore(end); else range.setEnd(container, container.childNodes.length);
      faq.append(range.extractContents());
      if (end) end.before(faq); else container.append(faq);
    });
    root.querySelectorAll('[data-affirm-page]').forEach(container => {
      if (container.dataset.ready) return;
      container.dataset.ready = 'true';
      // Only remove decorative screenshots. Leave every text node and link intact.
      [...container.querySelectorAll('img')].slice(1).filter(image => !image.closest('a,button')).forEach(image => image.remove());
      [...container.querySelectorAll('p,div')].reverse().forEach(node => {
        if (!node.textContent.trim() && !node.querySelector('img,iframe,script,style,input,button,a')) node.remove();
      });
    });
    root.querySelectorAll('.tn-original-faq[data-original-faq]').forEach(container => {
      if (container.dataset.introReady) return;
      container.dataset.introReady = 'true';
      const firstQuestion = container.querySelector('h4,h3,h2');
      if (!firstQuestion) return;
      const orderedNodes = [...container.querySelectorAll('p,h2,h3,h4')];
      const intro = orderedNodes.slice(0, orderedNodes.indexOf(firstQuestion)).filter(node => node.matches('p'));
      const greeting = intro.find(node => node.textContent.includes('Dear Customer!'));
      if (!greeting) return;
      greeting.innerHTML = 'Find answers to common questions about your TORNADO. If you need more help, <a href="/pages/contact-us">contact us</a> - we’re happy to help.';
      intro.filter(node => node !== greeting && (/Should you have any questions/.test(node.textContent) || /^\s*=+\s*$/.test(node.textContent))).forEach(node => node.remove());
    });
    root.querySelectorAll('[data-original-faq]').forEach(container => {
      if (container.dataset.ready) return;
      container.dataset.ready = 'true';
      // Copy ranges so nested Shopify rich-text lists retain all original text and links.
      const questions = [...container.querySelectorAll('h2,h3,h4,h5,h6,p')].filter(node => {
        const text = node.textContent.trim();
        return /\?\s*$/.test(text) && (node.matches('h2,h3,h4,h5,h6') || (node.querySelector('strong,b') && node.querySelector('strong,b').textContent.trim() === text));
      });
      if (!questions.length) return; // Unrecognized content stays visible, unchanged.
      const result = document.createDocumentFragment();
      const intro = document.createRange(); intro.setStart(container, 0); intro.setEndBefore(questions[0]); result.append(intro.cloneContents());
      questions.forEach((question, index) => {
        const details = document.createElement('details');
        const summary = document.createElement('summary'); summary.innerHTML = question.innerHTML;
        const body = document.createElement('div'); body.className = 'tn-prose';
        const range = document.createRange(); range.setStartAfter(question);
        if (questions[index + 1]) range.setEndBefore(questions[index + 1]); else range.setEnd(container, container.childNodes.length);
        body.append(range.cloneContents());
        // Discard blank rich-text paragraphs/list shells, including <p><br></p>.
        // Keep images and other meaningful non-text content.
        [...body.querySelectorAll('p,li,ul,ol,div')].reverse().forEach(node => {
          if (!node.textContent.trim() && !node.querySelector('img,svg,video,audio,iframe,table,input,button,hr')) node.remove();
        });
        details.append(summary, body); result.append(details);
      });
      const normalized = text => text.replace(/\s+/g, '');
      if (normalized(result.textContent) !== normalized(container.textContent)) return;
      container.replaceChildren(result);
      container.classList.add('tn-faq');
      // Keep the added seal answer in the same accordion group, with identical spacing.
      const sealGroup = container.nextElementSibling;
      if (sealGroup?.matches('.tn-seal-faq')) {
        container.append(...sealGroup.children);
        sealGroup.remove();
      }
    });
    root.querySelectorAll('[data-power-count]').forEach(counter => {
      if (counter.dataset.ready || reduced.matches) return;
      counter.dataset.ready = 'true';
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect(); const start = performance.now(); const target = Number(counter.dataset.powerCount);
        function frame(now) { const t = Math.min(1, (now - start) / 1200); counter.textContent = Math.round(target * (1 - Math.pow(1 - t, 3))); if (t < 1) requestAnimationFrame(frame); }
        requestAnimationFrame(frame);
      });
      observer.observe(counter);
    });
  }
  setup(); document.addEventListener('shopify:section:load', event => setup(event.target));
})();

(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 function setup(root = document) {
  root.querySelectorAll('[data-repeat-power]').forEach(counter => {
   if(counter.dataset.repeatReady) return;
   counter.dataset.repeatReady = 'true';
   const target = Number(counter.dataset.repeatPower);
   const node = counter.firstElementChild || counter;
   const duration = Math.max(500, Number(counter.dataset.duration || 2) * 1000);
   let frame = 0, armed = true;
   function finish(){cancelAnimationFrame(frame);node.textContent=String(target);}
   const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if(!entry.isIntersecting){finish();armed=true;return;}
    if(entry.intersectionRatio < .5 || !armed) return;
    armed=false;
    if(reduced.matches){finish();return;}
    const start=performance.now();node.textContent='0';
    function tick(now){const t=Math.min(1,(now-start)/duration);node.textContent=String(Math.round(target*(1-Math.pow(1-t,3))));if(t<1) frame=requestAnimationFrame(tick);}
    frame=requestAnimationFrame(tick);
   }),{threshold:[0,.5]});
   observer.observe(counter);
   reduced.addEventListener('change',finish);
   counter._tnCleanup=()=>{observer.disconnect();finish();reduced.removeEventListener('change',finish);};
  });
 }
 setup();document.addEventListener('shopify:section:load',e=>setup(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-repeat-power]').forEach(n=>n._tnCleanup?.()));
})();

// Both power figures share one observer, start time and animation frame.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root = document) {
    root.querySelectorAll('[data-power-pair]').forEach(pair => {
      if (pair.dataset.ready) return;
      pair.dataset.ready = 'true';
      const values = [...pair.querySelectorAll('[data-power-value]')];
      let frame = 0, armed = true;
      const paint = progress => values.forEach(node => {
        const value = Math.round(Number(node.dataset.powerValue) * progress);
        node.textContent = node.dataset.powerValue === '1800' ? String(value) : value.toLocaleString('en-US');
      });
      const finish = () => { cancelAnimationFrame(frame); paint(1); };
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) { finish(); armed = true; return; }
        if (entry.intersectionRatio < .25 || !armed) return;
        armed = false;
        if (reduced.matches) { finish(); return; }
        const start = performance.now(); paint(0);
        function tick(now) {
          const t = Math.min(1, (now - start) / 2000);
          paint(1 - Math.pow(1 - t, 3));
          if (t < 1) frame = requestAnimationFrame(tick);
        }
        frame = requestAnimationFrame(tick);
      }), { threshold: [0, .25] });
      observer.observe(pair); reduced.addEventListener('change', finish);
      pair._tnCleanup = () => { observer.disconnect(); finish(); reduced.removeEventListener('change', finish); };
    });
  }
  setup(); document.addEventListener('shopify:section:load', e => setup(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-power-pair]').forEach(n => n._tnCleanup?.()));
})();

// Keep Inbox above the purchase bar on every viewport, and clear the open cart.
(() => {
  let bar, sizeObserver, classObserver;
  function update() {
    document.documentElement.classList.toggle('tn-cart-open', !!document.querySelector('cart-drawer[open]'));
    const active = bar?.isConnected && bar.classList.contains('is-visible');
    const offset = active ? Math.max(20, innerHeight - bar.getBoundingClientRect().top + 16) : 20;
    document.documentElement.style.setProperty('--tn-chat-offset', `${Math.ceil(offset)}px`);
  }
  function setup() {
    sizeObserver?.disconnect(); classObserver?.disconnect();
    bar = document.querySelector('.product-quick-add');
    if (bar) {
      sizeObserver = new ResizeObserver(update); sizeObserver.observe(bar);
      classObserver = new MutationObserver(update); classObserver.observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    update();
  }
  setup(); addEventListener('resize', update);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', setup);
  // Variant changes may replace the native purchase bar.
  const replacements = new MutationObserver(() => {
    if (document.querySelector('.product-quick-add') !== bar) setup();
    else update();
  });
  replacements.observe(document.body, { childList: true, subtree: true, attributes:true, attributeFilter:['open'] });
})();
